const translations = {
  "en": {
    "From now on I'm pushing this with you — %{var0}.": "From now on I'm pushing this with you — %{var0}.",
    "From now on I'm pushing this with you.": "From now on I'm pushing this with you.",
    "Got it": "Got it",
    "Your goal is live": "Your goal is live"
  },
  "zh-tw": {
    "From now on I'm pushing this with you — %{var0}.": "從現在起，我會與您一同追蹤 %{var0}。",
    "From now on I'm pushing this with you.": "從現在起，我將與您持續追蹤並推進此項目標。",
    "Got it": "了解",
    "Your goal is live": "您的目標已啟用"
  }
};

export default translations;
